import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import { sortNumeric, selectFormat, sortDate } from "components/Utils/Utils.js";

class LeeTableSubscribersChurn extends Component {
  componentDidMount() {
    this.props.childRef(this);
    this.props.passRefUpward(this.childRef);
  }

  renderTable(data) {
    const { title } = this.props;

    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "start_month",
        text: "Start Month",
        style: { width: "140px", minWidth: "140px" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortDate,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "renewal_month",
        text: "Renewal Month",
        style: { width: "140px", minWidth: "140px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortDate,
      },
      {
        dataField: "initial_price",
        text: "Initial Price",
        style: { width: "100px", minWidth: "100px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "renewal_offer",
        text: "Renewal Offer",
        style: { width: "120px", minWidth: "120px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "up_for_renewal",
        text: "Renewal Offer",
        style: { width: "120px", minWidth: "120px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "renewed",
        text: "Renewed",
        style: { width: "100px", minWidth: "100px" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "renewal_rate",
        text: "Renewal Rate",
        style: { width: "120px", minWidth: "120px" },
        formatExtraData: { type: "percentage" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },

      {
        dataField: "eng_rate_converted",
        text: "Eng Rate (Converted)",
        style: { width: "140px", minWidth: "140px" },
        formatExtraData: { type: "percentage" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "eng_rate_churned",
        text: "Eng Rate (Churned)",
        style: { width: "140px", minWidth: "140px" },
        formatExtraData: { type: "percentage" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "eng_last_30_converted",
        text: "Eng Last 30 (Converted)",
        style: { width: "160px", minWidth: "160px" },
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "eng_last_30_churn",
        text: "Eng Last 30 (Churn)",
        style: { width: "150px", minWidth: "150px" },
        formatExtraData: { type: "percentage" },

        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0%"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "start_month",
        order: "desc",
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    // const { data } = this.props;

    // if (data.hasData === false) {
    //   return <Error minHeight={360} />;
    // }

    // data.data.forEach((d, i) => {
    //   d.id = i;
    //   d.title = d.title || d.brand_title;
    // });

    const data = [
      {
        start_month: "2021-10",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$99.00",
        up_for_renewal: 490,
        renewed: 49,
        renewal_rate: "10%",
        eng_rate_converted: "50%",
        eng_rate_churned: "30%",
        eng_last_30_converted: "40%",
        eng_last_30_churn: "25%",
      },
      {
        start_month: "2021-11",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$99.00",
        up_for_renewal: 3,
        renewed: 1,
        renewal_rate: "33%",
        eng_rate_converted: "80%",
        eng_rate_churned: "22%",
        eng_last_30_converted: "43%",
        eng_last_30_churn: "21%",
      },
      {
        start_month: "2022-02",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$99.00",
        up_for_renewal: 100,
        renewed: 3,
        renewal_rate: "3%",
        eng_rate_converted: "60%",
        eng_rate_churned: "11%",
        eng_last_30_converted: "39%",
        eng_last_30_churn: "18%",
      },
      {
        start_month: "2022-03",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$99.00",
        up_for_renewal: 60,
        renewed: 22,
        renewal_rate: "37%",
        eng_rate_converted: "55%",
        eng_rate_churned: "42%",
        eng_last_30_converted: "51%",
        eng_last_30_churn: "11%",
      },
      {
        start_month: "2022-04",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$99.00",
        up_for_renewal: 3,
        renewed: 1,
        renewal_rate: "33%",
        eng_rate_converted: "61%",
        eng_rate_churned: "37%",
        eng_last_30_converted: "42%",
        eng_last_30_churn: "31%",
      },
      {
        start_month: "2021-10",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$49.00",
        up_for_renewal: 200,
        renewed: 49,
        renewal_rate: "25%",
        eng_rate_converted: "50%",
        eng_rate_churned: "12%",
        eng_last_30_converted: "40%",
        eng_last_30_churn: "12%",
      },
      {
        start_month: "2021-11",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$49.00",
        up_for_renewal: 3,
        renewed: 2,
        renewal_rate: "67%",
        eng_rate_converted: "50%",
        eng_rate_churned: "9%",
        eng_last_30_converted: "40%",
        eng_last_30_churn: "5%",
      },
      {
        start_month: "2022-02",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$49.00",
        up_for_renewal: 125,
        renewed: 3,
        renewal_rate: "2%",
        eng_rate_converted: "50%",
        eng_rate_churned: "41%",
        eng_last_30_converted: "40%",
        eng_last_30_churn: "33%",
      },
      {
        start_month: "2022-03",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$49.00",
        up_for_renewal: 60,
        renewed: 29,
        renewal_rate: "48%",
        eng_rate_converted: "50%",
        eng_rate_churned: "22%",
        eng_last_30_converted: "40%",
        eng_last_30_churn: "17%",
      },
      {
        start_month: "2022-04",
        renewal_month: "2022-04",
        initial_price: "$1.00",
        renewal_offer: "$49.00",
        up_for_renewal: 3,
        renewed: 1,
        renewal_rate: "33%",
        eng_rate_converted: "50%",
        eng_rate_churned: "49%",
        eng_last_30_converted: "40%",
        eng_last_30_churn: "21%",
      },
    ];

    return this.renderTable(data);
  }
}

export default LeeTableSubscribersChurn;
